import React from 'react'
import { useAppFooterLogoStyles } from './app-footer-logo.styles'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setInitialState } from '../../../store/home-page-items/reducer'

type StyleProps = {
  resetOffset?: boolean
}

export const AppFooterLogo: React.FC<StyleProps> = (props): React.ReactElement => {
  const { resetOffset } = props
  const classes = useAppFooterLogoStyles()
  const dispatch = useDispatch()

  const onClickHandler = () => {
    dispatch(setInitialState())
  }
  return (
    <Link to="/" className={resetOffset ? [classes.root, classes.resetOffset].join(' ') : [classes.root].join(' ')} onClick={onClickHandler}>
      <img src="/images/logo-white.svg" className={classes.logo} alt="" />
      <img src="/images/logo-white.svg" className={classes.logoMini} alt="" />
    </Link>
  )
}
